// IntlTelInputWrapper.js
import React from "react";
import IntlTelInput from 'react-intl-tel-input';

const IntlTelInputWrapper = (props) => {
  return (
    <IntlTelInput
      {...props}
      preferredCountries={['ma']} 
      excludeCountries={['eh', 'il']} // exclude Western Sahara and Israel
    />
  );
}

export default IntlTelInputWrapper;